import { LegalLayout } from "@/components/site/LegalLayout";

export default function KycAmlPage() {
  return (
    <LegalLayout
      title="KYC & AML Verification Policy"
      lastUpdated="August 3, 2026"
      path="/kyc-aml-policy"
      metaTitle="KYC &amp; AML Verification Policy"
      metaDescription="Know-Your-Customer and Anti-Money-Laundering verification procedures for DC Dashboard users, including document requirements, sanctions screening, and ongoing monitoring."
    >
      <p>
        Danny Clans Media Limited ("Company") is committed to preventing fraud, money
        laundering, terrorist financing, sanctions violations, and other unlawful
        activities.
      </p>
      <p>This KYC and AML Verification Policy applies to all users of the DC Dashboard ("Platform").</p>

      <h2>1. Purpose</h2>
      <p>
        The Company may verify the identity, business activities, ownership, payment
        methods, and source of funds of any User at any time.
      </p>
      <p>
        The Company reserves the right to deny, suspend, restrict, or terminate
        services where satisfactory verification cannot be completed.
      </p>

      <h2>2. Verification Requirements</h2>
      <h3>Individual Users</h3>
      <ul>
        <li>Government-issued photo identification</li>
        <li>Proof of address</li>
        <li>Selfie verification</li>
        <li>Phone verification</li>
        <li>Payment method verification</li>
      </ul>

      <h3>Business Users</h3>
      <ul>
        <li>Certificate of incorporation</li>
        <li>Business registration documents</li>
        <li>Proof of business address</li>
        <li>Ownership structure information</li>
        <li>Authorized representative identification</li>
        <li>Tax registration documents</li>
      </ul>

      <h2>3. Payment Method Verification</h2>
      <p>The Company may request verification of:</p>
      <ul>
        <li>Credit cards</li>
        <li>Debit cards</li>
        <li>Bank accounts</li>
        <li>Wire transfer accounts</li>
        <li>Digital payment accounts</li>
      </ul>
      <p>Users may be required to prove ownership of payment methods used on the Platform.</p>

      <h2>4. Source of Funds</h2>
      <p>The Company may request information regarding the origin of funds used to:</p>
      <ul>
        <li>Fund Wallet balances</li>
        <li>Purchase services</li>
        <li>Pay advertising expenses</li>
        <li>Request withdrawals</li>
      </ul>
      <p>The Company may reject transactions where source-of-funds information is insufficient.</p>

      <h2>5. Sanctions Screening</h2>
      <p>The Company reserves the right to screen Users against:</p>
      <ul>
        <li>International sanctions lists (including OFAC, UN, EU, UK, and Hong Kong lists)</li>
        <li>Regulatory watchlists</li>
        <li>Anti-fraud databases</li>
        <li>Government enforcement lists</li>
      </ul>
      <p>Access may be denied where legal or compliance concerns arise.</p>

      <h2>6. Ongoing Monitoring</h2>
      <p>The Company may monitor:</p>
      <ul>
        <li>Transaction patterns</li>
        <li>Funding activity</li>
        <li>Withdrawal activity</li>
        <li>Advertising activity</li>
        <li>Geographic risk factors</li>
        <li>Chargeback activity</li>
      </ul>
      <p>Additional verification may be requested at any time.</p>

      <h2>7. Suspension of Services</h2>
      <p>The Company may suspend:</p>
      <ul>
        <li>Wallet funding</li>
        <li>Withdrawals</li>
        <li>Advertising accounts</li>
        <li>Platform access</li>
      </ul>
      <p>while verification reviews are conducted.</p>

      <h2>8. Reporting Obligations</h2>
      <p>
        Where required by law, the Company may disclose information to regulators, law
        enforcement agencies, financial institutions, or other authorized authorities.
      </p>

      <h2>9. No Liability</h2>
      <p>
        The Company shall not be liable for delays, restrictions, account freezes,
        transaction holds, or service interruptions resulting from compliance reviews
        or verification procedures.
      </p>

      <h2>10. Record Retention</h2>
      <p>
        Verification records may be retained for the period required by applicable law
        and for legitimate business purposes.
      </p>

      <h2>11. Contact</h2>
      <p>
        Compliance questions? Email{" "}
        <a href="mailto:help@dannyclans.com">help@dannyclans.com</a>.
      </p>
    </LegalLayout>
  );
}
